module.exports = (function() {
    'use strict';
    var pricePublisherMixin = require('../modules/mixins/price_publisher.mixin');
    var priceSubscriberMixin = require('../modules/mixins/price_subscriber.mixin');
    const trackingUtils = require('../modules/utils/tracking.utils');
    var creditCardTypes = require('../modules/data/credit_card_types');
    const CREDITCARD = 'CREDITCARD';
    const SECURE3D = 'SECURE3D';
    const NameOnCardModel = require('components/credit_card/name_on_card_field/js/model');
    const Cvv2Model = require('components/credit_card/cvv2_field/js/model');
    const CcExpirationDateModel = require('components/credit_card/cc_expiration_date/js/model');
    const logger = require('od-modules/utils/logger');
    const paymentInstrument = require('od-modules/utils/payment_instrument');
    const Fetcher = require('od-modules/utils/fetcher');
    const TIMEOUT_CONFIRM = 1000 * 60 * 4.9;
    const PAYMENT_OPTIONS_DELAY = 200;
    const isDesktop = () => Odigeo.SessionScope.flow === 'desktop';

    const checkCardFields = (cardFieldModels) => {
        Object.keys(cardFieldModels).forEach((name) => {
            cardFieldModels[name].checkValid();
        });
    };

    const createCardInfo = async(model, cardData, storedCardId) => {
        const cardFieldModels = model.get('cardFields');
        const owner = cardFieldModels.nameoncard.get('value') || cardData.owner;
        const cvvValue = cardFieldModels.cvv2.get('value');
        let paymentInstrumentToken;
        let paymentInstrumentTokenString;
        if (storedCardId.paymentInstrumentToken) {
            await paymentInstrument.updateCvv(storedCardId.paymentInstrumentToken, cvvValue);
            paymentInstrumentTokenString = storedCardId.paymentInstrumentToken;
        } else {
            const instrumentTokenBody = {
                'number': cardData.ccnumber.replace(/\s|\/|-/g, ''),
                'holder': owner,
                'expirationMonth': cardData.cardExpirationMonth ?
                    cardData.cardExpirationMonth : cardData.expirationDateMonth,
                'expirationYear': cardData.cardExpirationYear ?
                    cardData.cardExpirationYear : cardData.expirationDateYearFormated,
                'cvv': cvvValue,
            };
            paymentInstrumentToken = await paymentInstrument.generatePaymentInstrument(instrumentTokenBody);
            paymentInstrumentTokenString = `${paymentInstrumentToken.type}-${paymentInstrumentToken.uuid}`;
            await paymentInstrument.updateCvv(paymentInstrumentTokenString, cvvValue);
        }

        return {
            paymentInstrumentToken: paymentInstrumentTokenString,
            name: model.getCreditCardType(),
            typeCode: model.getCreditCardTypeCode(),
            storeCreditCardId: storedCardId.id,
        };
    };

    return priceSubscriberMixin.extend(pricePublisherMixin.extend({
        connect: true,
        selectors: ['expectedPrice', 'bookingId', 'primeMemberSelected'],
        paymentOptionsUrl: Odigeo.Settings.property('serviceUrlFormatter')('paymentoptions'),
        confirmPaymentUrl: Odigeo.Settings.property('serviceUrlFormatter')('confirm'),
        confirmShoppingBasketUrl: Odigeo.Settings.property('serviceUrlFormatter')('accommodationpostbooking/confirmshoppingbasket'),
        smsConsentUrl: '/travel/service/smsbookingconsent/store',
        amexType: ['AB', 'AX', 'TA'],
        defaultCreditCard: null,
        idealBank: null,

        defaults: {
            creditCardData: {},
            bookingUserComments: '',
            showCCDropdown: false,
        },

        validationRegExps: {
            creditCardData: {},
            invoiceRequestDTO: {},
        },

        init: function() {
            this.widget.options = Odigeo._.extend({isDynpack: false}, Odigeo.parseOptions(this.widget.options));
            const cardFields = {
                nameoncard: new NameOnCardModel(),
                cvv2: new Cvv2Model(),
            };

            Object.assign(cardFields, this.widget.options.cvvInline ? {
                ccExpirationDate: new CcExpirationDateModel(),
            } : {});

            this.set({
                defaultDataStorage: null,
                storedCCList: [],
                availablePaymentCCList: [],
                storedCCListValid: [],
                cardFields: cardFields,
            });

            this.on('change:chosenMethod', this.saveChosenMethodInSessionStorage, this);
        },

        resetCardFields() {
            this.set({
                cardFields: {
                    nameoncard: new NameOnCardModel(),
                    cvv2: new Cvv2Model(),
                },
            });
        },

        setEmptyCreditCard: function() {
            const creditCardFields = this.get('cardFields');

            this.set('creditCardData', {});
            if (isDesktop()) {
                Object.keys(creditCardFields).forEach((name) => {
                    creditCardFields[name].clear();
                });
            } else {
                creditCardFields.nameoncard.clear();
            }
        },

        setUserData: function(data) {
            this.set('user', data);
        },

        isValidCreditCardWithSpaces: function(value, parameter) {
            var pattern = new RegExp(this.widget.view.$cachedSelectors.ccnumber.data('pattern'));
            var str = value.replace(/\s|\/|-/g, '');
            var isValid = pattern.test(value);

            return isValid ? Odigeo.Utils.isValidCreditCard(str, parameter) : false;
        },

        getPaymentMethod: function() {
            return this.get('chosenMethod');
        },
        getCreditCardTypeError: function(cardData, errors) {
            if (this.get('showCCDropdown') && !cardData.cardTypeSelector) {
                errors.cardTypeSelector = 'empty';
            }

            return errors;
        },
        getFieldError: function(fieldName) {
            const fieldModel = this.get('cardFields')[fieldName];
            const error = fieldModel.validate(fieldModel.toJSON());
            return error ? {[fieldName]: error} : {};
        },
        getCreditCardNumberError: function(card, cardData, errors) {
            var param = {};
            var property = creditCardTypes[card.code] ? creditCardTypes[card.code].type : 'unknown';
            param[property] = true;
            if (Odigeo._.isEmpty(cardData.ccnumber) || !this.isValidCreditCardWithSpaces(cardData.ccnumber, param)) {
                errors.ccnumber = Odigeo._.isEmpty(cardData.ccnumber) ? 'empty' : 'invalid';
            }
            return errors;
        },
        getCreditCardExpirationError: function(cardData, errors) {
            var now = new Date();
            var fullNumExpYear = Number('20' + cardData.cardExpirationYear);
            if (!Odigeo._.isUndefined(cardData.cardExpirationYear) && !Odigeo._.isUndefined(cardData.cardExpirationMonth) &&
                !Odigeo._.isNaN(fullNumExpYear) &&
                cardData.cardExpirationYear !== '-1' && cardData.cardExpirationMonth !== '-1') {
                if (now.getUTCFullYear() > fullNumExpYear ||
                    (now.getUTCFullYear() === fullNumExpYear &&
                    now.getUTCMonth() + 1 > Number(cardData.cardExpirationMonth))) {
                    errors.creditCardExpiration = 'invalid';
                }
            } else {
                errors.creditCardExpiration = 'empty';
            }
            return errors;
        },
        validate(attrs) {
            let errors = {};
            let cardData;
            let card;
            let availableCodes;

            if (Odigeo._.isEmpty(attrs.paymentMethods)) {
                errors.paymentMethods = 'empty';
            } else if (!Odigeo._.isNumber(attrs.bookingId)) {
                errors.bookingId = 'invalid';
            } else if (attrs.chosenMethod === CREDITCARD) {
                card = attrs.chosenCard;
                availableCodes = Odigeo._.chain(attrs.paymentMethods)
                    .find(Odigeo._.matches({method: CREDITCARD}))
                    .result('info')
                    .result('cardTypes')
                    .pluck('code')
                    .value();
                cardData = attrs.creditCardData;
                if (Odigeo._.isUndefined(card) || !Odigeo._.contains(availableCodes, card.code)) {
                    errors.chosenCard = 'invalid';
                } else if (this.getSelectedStorageCreditCard()) {
                    Odigeo._.extend(errors, this.getFieldError('cvv2'));
                } else if (card.method === CREDITCARD || card.method === SECURE3D) {
                    errors = this.getCreditCardTypeError(cardData, errors);
                    Odigeo._.extend(errors, this.getFieldError('nameoncard'));
                    errors = this.getCreditCardNumberError(card, cardData, errors);
                    errors = this.getCreditCardExpirationError(cardData, errors);
                    Odigeo._.extend(errors, this.getFieldError('cvv2'));
                }
            } else if (!attrs.chosenMethod && this.widget.options.isMobileRevamp) {
                errors.chosenMethod = 'empty';
            }

            if (this.widget.options.enableButtonWhenFormIsValid) {
                Odigeo.trigger(this.widget.id + ':toogleButton', Odigeo._.isEmpty(errors));
            }

            if (!Odigeo._.isEmpty(errors)) {
                return errors;
            }
        },

        getCvvLength: function(code) {
            return Odigeo._.indexOf(this.amexType, code) > -1 ? 4 : 3;
        },

        parse: function(response, options) {
            var cardObj;
            var urlToCheck;

            if (Odigeo.Utils.parseJson(Odigeo.Session.get('isAccommodationPostBooking'))) {
                urlToCheck = this.confirmShoppingBasketUrl;
            } else {
                urlToCheck = this.confirmPaymentUrl;
            }

            if (options.url === urlToCheck) {
                this.set('response', response, {silent: true});
                this.trigger('change:response');
            } else if (Odigeo._.isUndefined(response) || Odigeo._.isEmpty(response.paymentMethods)) {
                if (!this.widget.bookingAlreadyDone) {
                    Odigeo.trigger(this.widget.id + ':noPaymentMethodsAvailable');
                }
            } else {
                var availablePaymentCCList = [];

                availablePaymentCCList = Odigeo._.chain(response.paymentMethods)
                    .findWhere({
                        method: CREDITCARD,
                    })
                    .result('info')
                    .result('cardTypes').value();
                cardObj = Odigeo._.findWhere(availablePaymentCCList, {code: response.chosenCard});

                response.presetCard = response.chosenCard = cardObj;
                response.chosenCard = this.attributes.chosenCard ? this.attributes.chosenCard : response.chosenCard;

                this.set('availablePaymentCCList', availablePaymentCCList);
            }

            return response;
        },

        setRegExp: function(cardTypes, attr, pattern) {
            var data;

            if (Odigeo._.includes(cardTypes, CREDITCARD)) {
                data = this.validationRegExps.creditCardData;
            }

            if (data) {
                data[attr] = new RegExp(pattern);
            }
        },

        setCardType: function(code) {
            var card;
            if (!!code && code !== '') {
                card = Odigeo._.chain(this.get('paymentMethods'))
                    .find({
                        method: CREDITCARD,
                    })
                    .result('info')
                    .result('cardTypes')
                    .find({
                        code: code,
                    })
                    .value();
            } else {
                card = this.get('presetCard');
            }
            this.set('chosenCard', card);
        },
        setIdealBank: function(bank) {
            this.set('idealBank', bank);
        },
        isIdealRequestValid: function() {
            const idealBank = this.get('idealBank');
            return (this.get('chosenMethod') === 'IDEAL' &&
            idealBank && idealBank !== '') || (this.get('chosenMethod') !== 'IDEAL');
        },
        setCardData: function(types, data) {
            if (!types) {
                return false;
            }

            var methods = types.split('|');
            var property;
            var cardData;
            var results;

            if (Odigeo._.includes(methods, CREDITCARD)) {
                property = 'creditCardData';
            }

            if (property) {
                cardData = Odigeo._.clone(this.get(property));

                Odigeo._.extend(cardData, data);

                results = this.set(property, cardData);
                this.saveCreditCardFields(cardData);

                // Force validation
                this.isValid();
                this.trigger('cardChanges', {changes: Odigeo._.keys(data), errors: this.validationError});
                Odigeo.trigger(this.widget.id + ':updateCardMethod');

                return results;
            }
            return false;
        },

        getPaymentOptions: function() {
            setTimeout(() => {
                const {isSubscriptionAdded: isPrimeSelected = false} = this.get('primeMemberSelected');
                this.fetch({
                    url: this.paymentOptionsUrl,
                    data: {isPrimeSelected},
                });
            }, PAYMENT_OPTIONS_DELAY);
        },

        saveChosenMethodInSessionStorage(method) {
            Odigeo.Session.set('chosenMethod', method.changed.chosenMethod);
        },
        showCCDropdown(showCCDropdown) {
            if (this.get('user')) {
                this.widget.view.$cachedSelectors.ccCardTypeShowed.find('option[value=""]').prop('selected', true);
            }
            this.set({showCCDropdown});
        },
        changePaymentMethodToOther: function() {
            const availableMethods = this.get('paymentMethods');

            const currentPaymentMethod = this.get('chosenMethod') || CREDITCARD;

            const firstOtherPaymentMethod = Odigeo._.find( availableMethods, (payMethod) => (payMethod.method !== currentPaymentMethod) );

            this.changePaymentMethod(firstOtherPaymentMethod.method);
        },
        changePaymentMethod: function(chosen) {
            if ( Odigeo._.isEmpty(chosen) ) {
                chosen = this.get('chosenMethod', chosen);
            }

            var availableMethods = this.get('paymentMethods');
            var methodIsAvailable = Odigeo._.some(availableMethods, Odigeo._.matches({
                method: chosen,
            }));
            var feeData;
            var feePrices;

            if (methodIsAvailable) {
                this.set('chosenMethod', chosen);

                if (chosen === CREDITCARD && this.isStoredCardsAvailability()) {
                    this.selectStorageCreditCard();
                }

                feeData = this.toJSON();

                if (feeData.chosenMethod === CREDITCARD) {
                    feePrices = {
                        concept: feeData.chosenCard.code,
                        onePrice: feeData.chosenCard.fee / this.widget.options.numTravellers,
                        allPrice: feeData.chosenCard.fee,
                        quantity: this.widget.options.numTravellers,
                        type: 'CC_FEE',
                        method: chosen,
                    };
                } else {
                    var paymentOption = Odigeo._.find(feeData.paymentMethods, Odigeo._.matches({
                        method: feeData.chosenMethod,
                    }));
                    feePrices = {
                        concept: paymentOption.description.name,
                        allPrice: paymentOption.fee,
                        onePrice: paymentOption.fee,
                        quantity: this.widget.options.numTravellers,
                        type: 'CC_FEE',
                        method: chosen,
                    };
                }
                this.trigger('feeChanges', feeData);
                this.addItemToPricemanagerCollection(feePrices);
            }
        },

        changeCreditCard: function(chosen, isResolved) {
            var cards = Odigeo._.find(this.get('paymentMethods'), {
                method: CREDITCARD,
            }).info.cardTypes;
            var foundCard = Odigeo._.find(cards, Odigeo._.matches({
                code: chosen,
            }));

            if (foundCard) {
                this.set({chosenCard: foundCard, ccResolved: isResolved});
                this.trigger('feeChanges', this.toJSON());
            }
        },

        setInvoiceRequestDTO: function(invoiceRequestDTO) {
            this.set('invoiceRequestDTO', invoiceRequestDTO);
        },

        setBookingUserComments: function(specialrequestDataString) {
            this.set('bookingUserComments', specialrequestDataString);
        },

        buildBuyerRequestDTO(bookingId, buyerInfo) {
            const buyerRequest = {};
            buyerRequest.bookingId = bookingId;
            buyerRequest.buyer = buyerInfo;
            buyerRequest.buyer.countryCode = Odigeo._.get(buyerInfo, 'country');
            return buyerRequest;
        },

        getExpectedPrice(valueFromPaymentButton) {
            return new Promise((resolve) => {
                this.widget.options.expectedPriceFromDOM
                    ? Odigeo.trigger(`${this.widget.id}:getExpectedPriceFromDOM`, resolve)
                    : resolve(this.getExpectedRawPrice(valueFromPaymentButton).toFixed(2));
            });
        },

        getExpectedRawPrice(valueFromPaymentButton) {
            return Odigeo.SessionScope.flow === 'mobile'
                ? this.getMobileExpectedPrice(valueFromPaymentButton)
                : this.getDesktopExpectedPrice();
        },

        getMobileExpectedPrice(valueFromPaymentButton) {
            return valueFromPaymentButton || this.getMobileExpectedPriceFromStore();
        },

        getMobileExpectedPriceFromStore() {
            return parseFloat(this.get('expectedPrice'));
        },

        getDesktopExpectedPrice() {
            if (Odigeo._.isObject(this.get('repricing'))) {
                return parseFloat(this.get('repricing').newPrice);
            } else {
                return parseFloat(this.getPriceCollectionData().totalPrice);
            }
        },

        async getRequest(params = {}) {
            let data;
            let cardData;
            let request;
            let paymentMethod;
            let types;
            let storedCardId;
            const selectedStorageCreditCard = this.getSelectedStorageCreditCard();
            const isAccommodationPostBooking = Odigeo.Utils.parseJson(Odigeo.Session.get('isAccommodationPostBooking'));
            const buyerInfo = Odigeo._.get(params, 'addBuyerInformationRequestDTO');
            const {expectedPrice} = params;

            if (this.isValid()) {
                data = this.toJSON();
                paymentMethod = (data.chosenMethod === CREDITCARD) ? data.chosenCard.method : data.chosenMethod;
                if (isAccommodationPostBooking) {
                    var bookingInfo = Odigeo.Utils.parseJson(Odigeo.Session.get('bookingInfo'));
                    request = {
                        paymentMethod: paymentMethod,
                        invoiceRequestDTO: data.invoiceRequestDTO,
                        email: bookingInfo.buyer.mail,
                        bookingId: bookingInfo.bookingBasicInfo.id,
                    };
                } else {
                    let expectedAmount = await this.getExpectedPrice(expectedPrice);
                    const accountCreationEnabled = !Odigeo.Session.get('accountCreationEnabled')
                        && Odigeo.Session.get('accountCreationEnabled') === null;
                    const repricing = this.get('repricing');
                    if (Odigeo._.isObject(repricing) && !Odigeo._.isNull(repricing.totalPriceDifference)) {
                        expectedAmount = expectedAmount + parseFloat(repricing.totalPriceDifference);
                    }
                    request = {
                        bookingId: data.bookingId,
                        bookingUserComments: data.bookingUserComments,
                        expectedAmmount: expectedAmount,
                        accountCreationEnabled,
                        expectedCurency: Odigeo.Utils.Currency.currencyCode,
                        idealRequest: data.chosenMethod === 'IDEAL' ? data.idealBank : null,
                        invoiceRequestDTO: data.invoiceRequestDTO,
                        addBuyerInformationRequestDTO: buyerInfo ? this.buildBuyerRequestDTO(data.bookingId, buyerInfo) : {},
                        newsletterSubscription:
                            (Odigeo.Session.get('changeNewsletterSubscriptionToken')
                                ? (Odigeo.Session.get('changeNewsletterSubscriptionToken') + '_true')
                                : 'U_false'
                            ),
                        paymentDetails: {
                            method: paymentMethod,
                        },
                        screenHeight: window.innerHeight.toString(),
                        screenWidth: window.innerWidth.toString(),
                    };
                }

                if (data.chosenMethod === CREDITCARD) {
                    types = data.chosenCard.method.split('|');

                    if (Odigeo._.includes(types, CREDITCARD)) {
                        cardData = data.creditCardData;
                        storedCardId = selectedStorageCreditCard ? selectedStorageCreditCard : {};
                        if (isAccommodationPostBooking) {
                            request.creditCardDetails = await createCardInfo(this, cardData, storedCardId);
                        } else {
                            request.paymentDetails.creditCardDetails = await createCardInfo(this, cardData, storedCardId);
                        }
                    }
                }
                return request;
            } else {
                return null;
            }
        },

        getCommitTrackingSuffixLabel: function(paymentMethod, defaultDataStorage, ccNumber) {
            var labelsPayMethodSuffix = {CREDITCARD: 'CC', BANKTRANSFER: 'BT', PAYPAL: 'PP', SOFORT: 'SF'};
            var labelSuffix = labelsPayMethodSuffix[paymentMethod];
            var storeType = '';
            var paymentData;

            if (defaultDataStorage === 'userAccount') {
                storeType = this.widget.view.$cachedSelectors.cardSaverManager.hasClass('odf-hidden') ?
                    '_saved_used' : '_standard_stored';
            } else if (defaultDataStorage === 'localStorage' && paymentMethod === CREDITCARD) {
                paymentData = Odigeo.Utils.parseJson(Odigeo.Storage.get('paymentData'));
                storeType = paymentData && paymentData.paymentMethod &&
                paymentData.paymentMethod.ccnumber === ccNumber ? '_saved_local_used' : '_standard_stored_local';
            }
            labelSuffix += storeType;

            if (!this.widget.view.$cachedSelectors.cardSaverManager.hasClass('odf-hidden') &&
                !this.widget.view.$cachedSelectors.saveCardData.is(':checked') && storeType !== '') {
                labelSuffix = labelSuffix + '_not';
            }
            return labelSuffix;
        },

        async commit(params = {}) {
            const isAccommodationPostBooking = Odigeo.Utils.parseJson(Odigeo.Session.get('isAccommodationPostBooking'));
            const {simulate = false} = params;
            const request = await this.getRequest(params);

            if (Odigeo.AB.isSmsConsent) {
                this.smsConsent();
            }

            if (request) {
                if (this.getPaymentMethod() === CREDITCARD) {
                    this.saveUserData();
                }
                if (!simulate) {
                    Odigeo.Storage.set('fromContinueButton', true);
                    Odigeo._.delay(() => {
                        this.save({}, {
                            attrs: request,
                            url: Odigeo.Utils.parseJson(Odigeo.Session.get('isAccommodationPostBooking')) ?
                                this.confirmShoppingBasketUrl : this.confirmPaymentUrl,
                            timeout: TIMEOUT_CONFIRM,
                            error: (jqXHR, status) => {
                                logger.message(`Error on confirm call;
                                     Status: ${status.statusText} - ${status.status};
                                     Ready state: ${status.readyState};
                                     Response text: ${status.responseText};
                                     Response json: ${status.responseJSON}`);
                                Odigeo.trigger(`${this.widget.id}:confirmError`, status);
                            },
                        });
                    }, 750);

                    var creditCardDetails;
                    var method;
                    if (isAccommodationPostBooking) {
                        creditCardDetails = request.creditCardDetails;
                        method = request.paymentMethod;
                    } else {
                        creditCardDetails = request.paymentDetails.creditCardDetails;
                        method = request.paymentDetails.method;
                    }

                    var ccNumber = creditCardDetails ? creditCardDetails.number : null;
                    this.widget.view._trackEvent('payment_details', 'payment_method_selected_' +
                        this.getCommitTrackingSuffixLabel(method, this.get('defaultDataStorage'), ccNumber));
                }
            } else {
                this.processCommitErrors(params);
            }
        },

        smsConsent: function() {
            Fetcher.post(this.smsConsentUrl, {
                shoppingId: Odigeo.Session.get('bookingId'),
                email: window.tc_vars.customer_email,
                consent: Odigeo.Session.get('sendSMSManageMyBookingsBuyerForm') === 'true',
                websiteCode: Odigeo.SessionScope.website,
            }, true).json();

            if (Odigeo.Session.get('sendSMSManageMyBookingsBuyerForm') === 'true') {
                trackingUtils.trackEvent('payment-sms-consent',
                    `payment-button-consent:1`);
            }
        },

        processCommitErrors({showErrorsResume = false, displayErrors = false} = {}) {
            if (!this.widget.options.isMobileRevamp || this.get('chosenMethod')) {
                this.showFieldErrors(showErrorsResume, displayErrors);
                checkCardFields(this.get('cardFields'));
            }
        },

        showFieldErrors(showErrorsResume, displayErrors, avoidTrackErrors = false) {
            this.widget.view.showErrors(
                {
                    errors: this.validationError,
                    opts: {all: true},
                    showErrorsResume: showErrorsResume,
                    displayErrors: displayErrors,
                    fullValidation: true,
                    avoidTrackErrors,
                }
            );
        },

        getCreditCardType: function() {
            return this.get('chosenCard').name;
        },

        getCreditCardTypeCode: function() {
            return this.get('chosenCard').code;
        },

        saveUserData: function() {
            if (this.get('defaultDataStorage') === 'userAccount') {
                this.widget.model.saveCard();
            }
        },
    }));
})();
